import { render, staticRenderFns } from "./ReferralCodePane.vue?vue&type=template&id=a4110cf4&scoped=true"
import script from "./ReferralCodePane.vue?vue&type=script&lang=ts"
export * from "./ReferralCodePane.vue?vue&type=script&lang=ts"
import style0 from "./ReferralCodePane.vue?vue&type=style&index=0&id=a4110cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4110cf4",
  null
  
)

export default component.exports